<template>
  <v-card flat tile min-height="380" class="d-flex flex-column">
    <confirm ref="confirm"></confirm>
    <v-card-text v-if="!path" class="grow d-flex justify-center align-center grey--text"
      >Selecione uma pasta ou um arquivo</v-card-text
    >
    <v-card-text v-else-if="isFile" class="grow d-flex justify-center align-center"
      >Arquivo: {{ path }}</v-card-text
    >
    <v-card-text v-else-if="dirs.length || files.length" class="grow">
      <v-list subheader v-if="dirs.length">
        <v-subheader>Pastas</v-subheader>
        <v-list-item
          v-for="item in dirs"
          :key="item.basename"
          @click="changePath(item.path)"
          class="pl-0"
        >
          <v-list-item-avatar class="ma-0">
            <v-icon>mdi-folder-outline</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="py-2">
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-row>
              <v-btn v-if="false" icon @click.stop="deleteItem(item)">
                <v-icon color="red lighten-1">mdi-delete-outline</v-icon>
              </v-btn>

              <RenameFolder
                v-on:folder-rename="folderRenamed"
                :pathPai="path"
                :projetoId="projetoId"
                :itemStorage="item"
              ></RenameFolder>
            </v-row>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-divider v-if="dirs.length && files.length"></v-divider>
      <v-list subheader v-if="files.length">
        <v-subheader>Arquivos</v-subheader>
        <v-list-item
          v-for="item in files"
          :key="item.basename"
          @click="changePath(item.path)"
          class="pl-0"
        >
          <v-list-item-avatar class="ma-0">
            <v-icon>{{ icons[item.extension.toLowerCase()] || icons["other"] }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content class="py-2">
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ formatBytes(item.size) }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action-text>
            <v-btn icon>
              <v-icon @click.stop="downloadItem(item)" color="primary lighten-1"
                >mdi-arrow-down-bold-circle-outline</v-icon
              >
            </v-btn>
            <v-btn
              v-if="false"
              icon
              @click.stop="deleteItem(item)"
              style="display: inline-block !important"
            >
              <v-icon color="grey lighten-1">mdi-delete-outline</v-icon>
            </v-btn>
          </v-list-item-action-text>
        </v-list-item>
      </v-list>
    </v-card-text>
    <v-card-text
      v-else-if="filter"
      class="grow d-flex justify-center align-center grey--text py-5"
      >No files or folders found</v-card-text
    >
    <v-card-text v-else class="grow d-flex justify-center align-center grey--text py-5"
      >The folder is empty</v-card-text
    >
    <v-divider v-if="path"></v-divider>
    <v-toolbar v-if="false && path && isFile" dense flat class="shrink">
      <v-btn icon>
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar v-if="path && isDir" dense flat class="shrink">
      <v-text-field
        solo
        flat
        hide-details
        label="Filter"
        v-model="filter"
        prepend-inner-icon="mdi-filter-outline"
        class="ml-n3"
      ></v-text-field>
      <v-btn icon v-if="false">
        <v-icon>mdi-eye-settings-outline</v-icon>
      </v-btn>
      <v-btn icon @click="load">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>
  </v-card>
</template>

<script>
import { formatBytes } from "./util";
import Confirm from "./Confirm.vue";
import RenameFolder from "./RenameFolder.vue";

const storageRequest = {};

export default {
  props: {
    icons: Object,
    storage: String,
    path: String,
    endpoints: Object,
    axios: Function,
    refreshPending: Boolean,
    projetoId: {
      require: false,
    },
  },
  components: {
    Confirm,
    RenameFolder,
  },
  data() {
    return {
      items: [],
      filter: "",
      newFolderPopper: false,
      newFolderName: "",
    };
  },
  computed: {
    dirs() {
      return this.items.filter(
        (item) =>
          item.type === "dir" &&
          item.path !== this.path &&
          item.basename.includes(this.filter)
      );
    },
    files() {
      return this.items.filter(
        (item) => item.type === "file" && item.basename.includes(this.filter)
      );
    },
    isDir() {
      return this.path[this.path.length - 1] === "/";
    },
    isFile() {
      return !this.isDir;
    },
  },
  methods: {
    formatBytes,
    changePath(path) {
      this.$emit("path-changed", path);
    },
    folderRenamed(path) {
      this.$emit("folder-rename", path);
    },
    async load() {
      this.$emit("loading", true);
      if (this.isDir) {
        const payload = {
          projetoId: this.projetoId,
          path: this.path,
        };

        let response = await this.$store.dispatch("storage/list", payload);

        //let response = await storageRequest.list(this.projetoId, this.path);
        storageRequest;
        this.items = response.data;
      } else {
        // TODO: load file
      }
      this.$emit("loading", false);
    },
    async downloadItem(item) {
      //this.$emit("loading", true);
      await storageRequest.download(item.projeto.id, item.id);
      //this.$emit("file-downloaded");
      //this.$emit("loading", false);
    },
    async deleteItem(item) {
      let confirmed = await this.$refs.confirm.open(
        "Confirmação de Exclusão",
        `${
          item.type === "dir"
            ? "Lembre-se: Ao remover esta pasta, ela não poderá ser recuperada."
            : "Lembre-se: Ao remover este arquivo, ele não poderá ser recuperado."
        }Tem certeza de que deseja continuar?<br><br><em>${item.basename}</em><br>`
      );

      if (confirmed) {
        this.$emit("loading", true);
        let url = this.endpoints.delete.url
          .replace(new RegExp("{storage}", "g"), this.storage)
          .replace(new RegExp("{path}", "g"), item.path);

        let config = {
          url,
          method: this.endpoints.delete.method || "post",
        };

        await this.axios.request(config);
        this.$emit("file-deleted");
        this.$emit("loading", false);
      }
    },
  },
  watch: {
    async path() {
      this.items = [];
      await this.load();
    },
    async refreshPending() {
      console.log(
        "refreshPendingrefreshPendingrefreshPendingrefreshPendingrefreshPending"
      );
      if (this.refreshPending) {
        await this.load();
        this.$emit("refreshed");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  height: 100%;
}
</style>
